<div
  class="custom-control custom-checkbox table-checkbox"
  ngbTooltip="{{ 'Select all on page' | translate }}"
>
  <input
    type="checkbox"
    class="custom-control-input"
    name="selectAll"
    id="selectAll"
    (click)="onSelectAll()"
    [checked]="selectedOnPage[page] === length"
    [disabled]="!length"
  />
  <label class="custom-control-label" for="selectAll">&nbsp;</label>
</div>
